<template>
  <div>
    <!-- 广告栏 -->
    <div class="banner-container">
      <img class="banner-image" v-if="url" :src="url" />
      <img class="banner-image" v-else src="https://aimg8.oss-cn-shanghai.aliyuncs.com/website/wap_bargain/banner.png" />
      <!-- <img class="banner-coin" src="../../../../static/images/bargain/coin.png" /> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {};
  },
  props: {
    url: String
  },
  components: {}
};
</script>

<style scoped lang="scss">
.banner-container {
  position: relative;
  width: 100%;
  height: 3.1rem;
  .banner-image {
    display: block;
    width: 100%;
    height: 100%;
  }
  .banner-coin {
    width: 0.76rem;
    height: 0.67rem;
    position: absolute;
    right: -0.18rem;
    bottom: -0.38rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Bargain/components/Banner.vue